<!-- Item wrapper -->
<div class="calsoft-horizontal-navigation-item-wrapper"
     [class.calsoft-horizontal-navigation-item-has-subtitle]="!!item.subtitle"
     [ngClass]="item.classes">

    <!-- Item with an internal link -->
    <div class="calsoft-horizontal-navigation-item"
         *ngIf="item.link && !item.externalLink && !item.function && !item.disabled"
         [routerLink]="[item.link]"
         [routerLinkActive]="'calsoft-horizontal-navigation-item-active'"
         [routerLinkActiveOptions]="{exact: item.exactMatch || false}">
        <ng-container *ngTemplateOutlet="itemTemplate"></ng-container>
    </div>

    <!-- Item with an external link -->
    <a class="calsoft-horizontal-navigation-item"
       *ngIf="item.link && item.externalLink && !item.function && !item.disabled"
       [href]="item.link">
        <ng-container *ngTemplateOutlet="itemTemplate"></ng-container>
    </a>

    <!-- Item with a function -->
    <div class="calsoft-horizontal-navigation-item"
         *ngIf="!item.link && item.function && !item.disabled"
         (click)="item.function(item)">
        <ng-container *ngTemplateOutlet="itemTemplate"></ng-container>
    </div>

    <!-- Item with an internal link and function -->
    <div class="calsoft-horizontal-navigation-item"
         *ngIf="item.link && !item.externalLink && item.function && !item.disabled"
         [routerLink]="[item.link]"
         [routerLinkActive]="'calsoft-horizontal-navigation-item-active'"
         [routerLinkActiveOptions]="{exact: item.exactMatch || false}"
         (click)="item.function(item)">
        <ng-container *ngTemplateOutlet="itemTemplate"></ng-container>
    </div>

    <!-- Item with an external link and function -->
    <a [attr.guide]="'basic-lnk-1' + '__' + sanitizeUrl(url)" class="calsoft-horizontal-navigation-item"
       *ngIf="item.link && item.externalLink && item.function && !item.disabled"
       [href]="item.link"
       (click)="item.function(item)"
       mat-menu-item>
        <ng-container *ngTemplateOutlet="itemTemplate"></ng-container>
    </a>

    <!-- Item with a no link and no function -->
    <div class="calsoft-horizontal-navigation-item"
         *ngIf="!item.link && !item.function && !item.disabled">
        <ng-container *ngTemplateOutlet="itemTemplate"></ng-container>
    </div>

    <!-- Item is disabled -->
    <div class="calsoft-horizontal-navigation-item calsoft-horizontal-navigation-item-disabled"
         *ngIf="item.disabled">
        <ng-container *ngTemplateOutlet="itemTemplate"></ng-container>
    </div>

</div>

<!-- Item template -->
<ng-template #itemTemplate>

    <!-- Icon -->
    <mat-icon class="calsoft-horizontal-navigation-item-icon"
              [ngClass]="item.iconClasses"
              *ngIf="item.icon"
              [svgIcon]="item.icon"></mat-icon>

    <!-- Title & Subtitle -->
    <div class="calsoft-horizontal-navigation-item-title-wrapper">
        <div class="calsoft-horizontal-navigation-item-title">{{item.defaultName | titlecase}}</div>
        <div class="calsoft-horizontal-navigation-item-subtitle text-hint"
             *ngIf="item.subtitle">
            {{item.subtitle | titlecase}}
        </div>
    </div>

    <!-- Badge -->
    <div class="calsoft-horizontal-navigation-item-badge"
         *ngIf="item.badge">
        <div class="calsoft-horizontal-navigation-item-badge-content"
             [ngClass]="[(item.badge.style != undefined ? 'calsoft-horizontal-navigation-item-badge-style-' + item.badge.style : ''),
                             (item.badge.background != undefined && !item.badge.background.startsWith('#') ? item.badge.background : ''),
                             (item.badge.color != undefined && !item.badge.color.startsWith('#') ? item.badge.color : '')]"
             [ngStyle]="{'background-color': item.badge.background, 'color': item.badge.color}">
            {{item.badge.title | titlecase}}
        </div>
    </div>

</ng-template>
